import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent, Typography } from '@mui/material'
import { isNil } from 'lodash'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'
import NoteCard from 'gdl/notes/NoteCard'

// La dernière note est déjà présente dans le payload des clients (GDL/customer inclut notes),
// on l'affiche directement sans appel réseau.
const LastNoteDialog = ({ open, onClose, note, customerName = '' }) => (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
        <BasicDialogTitle onClose={onClose}>{`Dernière note — ${customerName}`}</BasicDialogTitle>
        <DialogContent sx={{ paddingTop: 2 }}>
            {isNil(note)
                ? <Typography color='textSecondary'>{'Aucune note pour ce client.'}</Typography>
                : <NoteCard note={note} readMode />}
        </DialogContent>
    </Dialog>
)

LastNoteDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    note: PropTypes.shape({}),
    customerName: PropTypes.string,
}

export default LastNoteDialog
